import { createTheme } from "@mui/material";

export const Colors = {
  primary: "#2563EB",
  primaryDark: "#1E40AF",
  primaryDeep: "#1E3A5F",
  primaryLight: "#3B82F6",
  accent: "#2563EB",
  accentHover: "#1D4ED8",
  secondary: "#ffffff",
  light_gray: "#94A3B8",
  bgColor: "#F8FAFC",
  BgColorLite: "#EFF6FF",
  secondaryColor: "#64748B",
  primaryTextColor: "#0F172A",
  menuItemBgColor: "#EFF6FF",
  dividerColor: "#E2E8F0",
  white: "#ffffff",
  tableHeaderBorder: "#E2E8F0",
  hoverColorBtn: "#1D4ED8",
  success: "#16A34A",
  error: "#DC2626",
  warning: "#D97706",
  heroBg: "#ffffff",
  heroGradient: "linear-gradient(135deg, #EFF6FF 0%, #DBEAFE 50%, #F8FAFC 100%)",
  cardDark: "#1E3A5F",
  footerBg: "#0F172A",
  sectionDark: "#0F172A",
  glassBg: "rgba(37,99,235,0.04)",
  glassBorder: "rgba(37,99,235,0.08)",
  blueGlow: "rgba(37,99,235,0.08)",
  blueSoft: "#EFF6FF",
  blueMid: "#DBEAFE",
  blueBorder: "#BFDBFE",
  insuranceGreen: "#059669",
  insuranceGreenDark: "#047857",
  insuranceGreenLight: "#10B981",
  greenSoft: "#ECFDF5",
  greenMid: "#D1FAE5",
  greenBorder: "#A7F3D0",
  greenGlow: "rgba(5,150,105,0.08)",
};

const theme = createTheme({
  palette: {
    primary: { main: Colors.primary, light: Colors.primaryLight, dark: Colors.primaryDark, contrastText: Colors.white },
    secondary: { main: Colors.secondary },
    error: { main: Colors.error, contrastText: "#fff" },
    ChipColor: { main: Colors.blueSoft, contrastText: Colors.primary },
    divider: Colors.dividerColor,
    background: { default: Colors.bgColor, paper: Colors.white },
  },
  breakpoints: {
    values: { xs: 0, sm: 400, md: 900, mds: 1000, lg: 1200, xl: 1536, uxl: 2000 },
  },
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    h1: { fontWeight: 700, letterSpacing: "-0.04em", lineHeight: 1.08 },
    h2: { fontWeight: 700, letterSpacing: "-0.03em", lineHeight: 1.1 },
    h3: { fontWeight: 700, letterSpacing: "-0.02em", lineHeight: 1.15 },
    h4: { fontWeight: 700, letterSpacing: "-0.02em", lineHeight: 1.2 },
    h5: { fontWeight: 600, letterSpacing: "-0.01em", lineHeight: 1.25 },
    h6: { fontWeight: 600, lineHeight: 1.35 },
    body1: { fontWeight: 400, lineHeight: 1.7, color: Colors.secondaryColor },
    body2: { fontWeight: 400, lineHeight: 1.6, color: Colors.secondaryColor },
    button: { fontWeight: 600, textTransform: "none", letterSpacing: "-0.01em" },
  },
  shape: { borderRadius: 8 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none", borderRadius: 8, fontWeight: 600, boxShadow: "none",
          "&:hover": { boxShadow: "none" },
        },
        contained: {
          "&:hover": { boxShadow: "0 2px 8px rgba(37, 99, 235, 0.25)" },
        },
      },
    },
    MuiCard: { styleOverrides: { root: { borderRadius: 12, boxShadow: "0 1px 2px rgba(0,0,0,0.04)" } } },
    MuiPaper: { styleOverrides: { root: { borderRadius: 12, boxShadow: "0 1px 2px rgba(0,0,0,0.04)" } } },
    MuiDivider: { styleOverrides: { root: { backgroundColor: Colors.dividerColor } } },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: 8,
            "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: Colors.primary },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: Colors.primary, borderWidth: 2 },
          },
        },
      },
    },
  },
});

export default theme;
